import { Button, Grid } from "@scuf/common";
import { useState } from "react";
import AcidoProducido from "./components/acidoProducido";
import CalcinaProducida from "./components/calcinaProducida";
import Rendimiento from "./components/rendimiento";
import SiliceConsumida from "./components/siliceConsumida";
import TratamientoConcentradoBs from "./components/tratamientoConcentradoBs";
import UtilizadorTostador from "./components/utilizacionTostador";
import "./Home.css";

/**
 * Página de entrada, muestra la vista estrategico
 * @returns JXS Home
 */
export default function Home() {
  // Inicializacion de los botones de nuestro rango de frecuencia
  const [state, setState] = useState({
    buttonGroup: [
      { content: "Semana", type: "primary" },
      { content: "Mes", type: "secondary" },
      { content: "Año", type: "secondary" },
    ],
  });

  // S: semana, M: mes, A: año
  // esta propiedad la bajaremos a las vistas que esten dentro de home
  const [rangeSelected, setRangeSelected] = useState("S");

  /**
   * Metodo que cambia los botones de type
   * @param {*} clickedButtonIndex
   * @param {*} buttonData
   */
  function toggleButton(clickedButtonIndex, buttonData) {
    const buttons = state.buttonGroup;
    // eslint-disable-next-line array-callback-return
    buttons.map((button, index) => {
      if (clickedButtonIndex !== index) {
        buttons[index].type = "secondary";
      } else {
        buttons[index].type = "primary";
      }
    });
    setState({ buttonGroup: buttons });

    const { content } = state.buttonGroup.find(
      (button) => button.type === "primary"
    );

    if (content) {
      setRangeSelected(String(content).charAt(0).toUpperCase());
    }
  }

  return (
    <>
      <Grid>
        {/* Fila para montar un selector de rangos de fecha */}
        <Grid.Row>
          <Grid.Column className="range-dates-container" width={12}>
            {/* Grupo de botones */}
            <Button.Group>
              {state.buttonGroup.map((buttonData, index) => {
                return (
                  <Button
                    key={index}
                    content={buttonData.content}
                    type={buttonData.type}
                    onClick={() => toggleButton(index, buttonData)}
                  />
                );
              })}
            </Button.Group>
          </Grid.Column>
        </Grid.Row>

        {/* Fila para montar todo el contenido de la pagina */}
        <Grid.Row>
          <Grid.Column width={6} mWidth={12}>
            <TratamientoConcentradoBs periodo={rangeSelected} />
          </Grid.Column>
          <Grid.Column width={6} mWidth={12}>
            <Rendimiento periodo={rangeSelected} />
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column width={6} mWidth={12}>
            <UtilizadorTostador periodo={rangeSelected} />
          </Grid.Column>
          <Grid.Column width={6} mWidth={12}>
            <CalcinaProducida periodo={rangeSelected} />
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column width={6} mWidth={12}>
            <AcidoProducido periodo={rangeSelected} />
          </Grid.Column>
          <Grid.Column width={6} mWidth={12}>
            <SiliceConsumida periodo={rangeSelected} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
}
